import { render, staticRenderFns } from "./performTsksDetails.vue?vue&type=template&id=32d4f3fa&scoped=true&"
import script from "./performTsksDetails.vue?vue&type=script&lang=js&"
export * from "./performTsksDetails.vue?vue&type=script&lang=js&"
import style0 from "./performTsksDetails.vue?vue&type=style&index=0&id=32d4f3fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d4f3fa",
  null
  
)

export default component.exports